import {all, call, put, takeEvery} from 'redux-saga/effects'
import {
  ResourcesActionTypes,
  fetchError,
  fetchSuccess
} from '@actions/resources';
import resourcesApi from '@api/resources'
import {ReduxAction} from "@actions/index";

function* handleFetch({payload}: ReduxAction) {
  try {
    const res = yield call(resourcesApi.getList, payload);
    yield put(fetchSuccess(res))
  } catch (err) {
    yield put(fetchError(err.stack!))
  }
}


// We can also use `fork()` here to split our saga into multiple watchers.
function* resourcesSaga() {
  yield all([
    yield takeEvery(ResourcesActionTypes.FETCH_REQUEST, handleFetch),
  ])
}

export default resourcesSaga;
